import React from 'react'
import { Chip } from '@mui/material'

const STATUS = {
    AUTHORIZED: {
        label: 'Autorizada',
        color: 'green',
        backgroundColor: '#e8f5e9',
        textColor: '#1b5e20',
    },
    AUTHORIZED_AFTER_CONTINGENCY: {
        label: 'Autorizada após contingência',
        color: 'green',
        backgroundColor: '#e8f5e9',
        textColor: '#1b5e20',
    },
    IN_CONTINGENCY: {
        label: 'Em contingência',
        color: 'yellow',
        backgroundColor: '#fff8e1',
        textColor: '#8a6d00',
    },
    PENDING: {
        label: 'Pendente',
        color: 'yellow',
        backgroundColor: '#fff8e1',
        textColor: '#8a6d00',
    },
    CANCELLED: {
        label: 'Cancelada',
        color: 'red',
        backgroundColor: '#ffebee',
        textColor: '#b71c1c',
    },
    INVALIDATED: {
        label: 'Inutilizada',
        color: 'gray',
        backgroundColor: '#eceff1',
        textColor: '#455a64',
    },
}

export default function NfceStatusChip({ status, label }) {
    const config = STATUS[status] || {
        label: label || 'N/A',
        color: 'gray',
        backgroundColor: '#eceff1',
        textColor: '#455a64',
    }

    return (
        <Chip
            label={label || config.label}
            size="small"
            data-status-color={config.color}
            sx={{
                backgroundColor: config.backgroundColor,
                color: config.textColor,
                fontWeight: 700,
            }}
        />
    )
}
